import { useState } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCategorySelect = (url: string) => {
    setDropdownOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20overhead%20flat%20lay%20of%20diverse%20fashion%20items%20sneakers%20watch%20sunglasses%20scarf%20and%20bag%20arranged%20in%20circular%20composition%20on%20dark%20slate%20surface%20dramatic%20top-down%20lighting%20bold%20shadows%20luxury%20editorial%20aesthetic%20rich%20contrast%20high%20detail%20magazine%20quality&width=1800&height=900&seq=hero-v2-2026&orientation=landscape"
          alt="PandabuySpreadsheet product collection"
          className="w-full h-full object-cover object-top"
          title="PandabuySpreadsheet - Smart Product Comparison Hub"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-[900px] mx-auto">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 animate-fade-in-up">
            PandabuySpreadsheet
          </h1>
          <p className="font-heading text-xl md:text-2xl italic text-background-50/90 mb-6 animate-fade-in-up animation-delay-100">
            The Smart Way to Compare Products Before You Buy
          </p>

          <p className="text-background-50/75 text-sm md:text-base max-w-[600px] mx-auto mb-10 leading-relaxed animate-fade-in-up animation-delay-200">
            Make better buying decisions using structured product spreadsheets, data-driven comparisons, and real-world cost analysis across all your favorite categories.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 animate-fade-in-up animation-delay-300">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line"></i>
              Pandabuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line"></i>
              Buy It Now
            </a>
          </div>

          <div className="relative inline-block">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-3 px-6 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-grid-line"></i>
              <span>Browse All Categories</span>
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {dropdownOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setDropdownOpen(false)}></div>
                <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-72 bg-background-50 rounded-lg overflow-hidden z-50 max-h-[420px] overflow-y-auto shadow-lg">
                  {categories.map((cat) => (
                    <button
                      key={cat.imageUrl}
                      onClick={() => handleCategorySelect(cat.url)}
                      className="w-full text-left px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors duration-150 border-b border-background-200/70 last:border-b-0 cursor-pointer whitespace-nowrap flex items-center justify-between group"
                    >
                      <span>{cat.name}</span>
                      <i className="ri-arrow-right-line text-xs text-foreground-400 group-hover:text-foreground-600 transition-colors"></i>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
      </div>
    </section>
  );
}